import { Component, type OnInit } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { TransifexTranslatePipe } from '../../../../pipes/transifex-translate.pipe'
@Component({
  standalone: true,
  selector: 'customer-portal-app-brand',
  templateUrl: './brand.component.html',
  imports: [MatIcon, TransifexTranslatePipe]
})
export class BrandComponent implements OnInit {
  countryCode: string
  constructor (
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {}

  ngOnInit (): void {
    this.countryCode = this.remoteConfigService.get('country.code')
  }
}
